import { Link } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';

import { GUIDE_DOCS_OUT_LINK_TYPE, type GuideDocsOutLinkProps } from './types';

/**
 * 기술 문서 외부 링크 컴포넌트
 * @param props - GuideDocsOutLinkProps
 * @returns
 * ```tsx
 * <Link external href={href} size={size} aria-label={ariaLabel} {...rest} >
 *   기술 문서 바로가기 or 자세히 보기
 * </Link>
 * ```
 * @example
 * <ManagementPageOutLink href="https://console.kakaocloud.com" size="sm" aria-label="management-page-out-link" message="Load Balancing > 대상 그룹 목록으로 이동" />
 */
const GuideDocsOutLink = (props: GuideDocsOutLinkProps) => {
  const { t } = useTranslation();
  const {
    href,
    size = 'xs',
    'aria-label': ariaLabel = 'guide-docs-out-link',
    type = GUIDE_DOCS_OUT_LINK_TYPE.DIRECT_LINK,
    ...rest
  } = props;

  return (
    <Link external href={href} size={size} aria-label={ariaLabel} {...rest}>
      {type === GUIDE_DOCS_OUT_LINK_TYPE.DIRECT_LINK
        ? t('common:common.link.user_guide')
        : t('common:common.link.learn_more')}
    </Link>
  );
};

export default GuideDocsOutLink;
